// Global keyboard shortcut registry.
// Components: useEffect(() => registerShortcut('save', fn), []) — returns unregister fn.
const handlers = { save: [], escape: [] };

export function registerShortcut(action, fn) {
  handlers[action] = handlers[action] || [];
  handlers[action].push(fn);
  return () => { handlers[action] = handlers[action].filter(f => f !== fn); };
}

export function initShortcuts(openSearch) {
  const onKey = (e) => {
    const tag = (document.activeElement?.tagName || '').toLowerCase();
    const typing = tag === 'input' || tag === 'textarea' || tag === 'select' || document.activeElement?.isContentEditable;

    // Ctrl/Cmd+S -> save (topmost registered handler)
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
      const list = handlers.save || [];
      if (list.length) { e.preventDefault(); list[list.length - 1](); }
      else e.preventDefault(); // still block browser save dialog
      return;
    }
    // Ctrl/Cmd+K or '/' -> global search
    if (((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') || (!typing && e.key === '/')) {
      e.preventDefault(); openSearch();
      return;
    }
    // Esc -> topmost escape handler (modals register these)
    if (e.key === 'Escape') {
      const list = handlers.escape || [];
      if (list.length) { list[list.length - 1](); }
    }
  };
  window.addEventListener('keydown', onKey);
  return () => window.removeEventListener('keydown', onKey);
}
